import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Row,
  Input,
  Label,
  Form,
  Spinner,
  Button,
  Container,
  Card,
  CardBody,
  CardHeader,
  Alert,
} from "reactstrap";
import { getUser, editUser, resetUsuarioFlag } from "../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Select from "react-select";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { uploadFotoPerfil, deleteFotoPerfil } from "../../helpers/backend_helper";
import avatarDefault from "../../assets/images/users/avatar-1.jpg";

const EditarUsuario = () => {
  // console.log("EditarUsuario");
  const dispatch = useDispatch();
  const opcionesPerfil = [
    "Administrador",
    "Delivery",
    "Farmacia",
    "Farmabien",
    "MyHealth",
    "ClienteAPI",
  ];

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      // console.log("useEffect de UsuarioEditar se ejecuto con id:", obj.id);
      dispatch(getUser(obj.id));
    }
  }, [dispatch]);

  const selectLayoutState = (state) => state;
  const usuarioPageData = createSelector(selectLayoutState, (state) => ({
    usuario: state.Usuarios.usuario,
    error: state.Usuarios.error,
    loading: state.Usuarios.loading,
    errorMsg: state.Usuarios.errorMsg,
    colorMsg: state.Usuarios.colorMsg,
    exito: state.Usuarios.exito,
  }));
  const { usuario, exito, error, loading, errorMsg, colorMsg } =
    useSelector(usuarioPageData);

  // Estados
  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  }, [dispatch, loading]);

  useEffect(() => {
    if (errorMsg) {
      // console.log("useEffect errorMsg is true");
      setTimeout(() => {
        dispatch(resetUsuarioFlag());
      }, 2000);
    }
  }, [dispatch, errorMsg]);

  useEffect(() => {
    if (usuario && Object.keys(usuario).length > 0) {
      setNombre(usuario.nombre || "");
      setApellido(usuario.apellido || "");
      setCorreo(usuario.correo || "");
      setTelefono(usuario.telefono || "");
      setUsuarioRol(usuario.usuario || "");
      setCreado(usuario.creado || "");
      setActivo(usuario.activo || false);
      setContrasena("");
      setPerfil(usuario.perfil || "");
      setFotoPerfil(usuario.foto_perfil || null);

      setPerfilOptionSelect({
        value: usuario.perfil || "",
        label: usuario.perfil || "",
      });

      setActivoOptionSelect({
        value: usuario.activo || false,
        label: usuario.activo ? "Si" : "No",
      });
    }
  }, [usuario]);

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [telefono, setTelefono] = useState("");
  const [usuarioRol, setUsuarioRol] = useState("");
  const [creado, setCreado] = useState("");
  const [activo, setActivo] = useState(false);
  const [contrasena, setContrasena] = useState("");
  const [perfil, setPerfil] = useState("");
  const [perfilOptionSelect, setPerfilOptionSelect] = useState(null);
  const [activoOptionSelect, setActivoOptionSelect] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [fotoPerfil, setFotoPerfil] = useState(null);
  const [uploadingFoto, setUploadingFoto] = useState(false);
  const [fotoError, setFotoError] = useState(null);
  const fileInputRef = useRef(null);

  // Función para manejar el cambio de contraseña
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setContrasena(value);

    // Validación de contraseña
    const errors = [];
    if (value.length < 8) {
      errors.push("La contraseña debe tener al menos 8 caracteres");
    }
    if (!/[A-Z]/.test(value)) {
      errors.push("La contraseña debe contener al menos una mayúscula");
    }
    if (!/[a-z]/.test(value)) {
      errors.push("La contraseña debe contener al menos una minúscula");
    }
    if (!/[0-9]/.test(value)) {
      errors.push("La contraseña debe contener al menos un número");
    }

    setPasswordError(errors.length > 0 ? errors : null);
  };

  // Función para alternar la visibilidad de la contraseña
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Función para manejar la subida de foto de perfil
  const handleFotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    if (!file.type.startsWith('image/')) {
      setFotoError('Por favor selecciona una imagen válida');
      return;
    }

    // Validar tamaño (máx 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setFotoError('La imagen no debe superar los 5MB');
      return;
    }

    setUploadingFoto(true);
    setFotoError(null);

    try {
      // Convertir a base64
      const reader = new FileReader();
      reader.onloadend = async () => {
        try {
          const base64 = reader.result;
          const response = await uploadFotoPerfil(base64);
          
          if (response?.data?.data?.foto_perfil) {
            const nuevaFoto = response.data.data.foto_perfil;
            setFotoPerfil(nuevaFoto);
            // Actualizar localStorage
            const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
            authUser.foto_perfil = nuevaFoto;
            localStorage.setItem("authUser", JSON.stringify(authUser));
            // Disparar evento para actualizar el topbar
            window.dispatchEvent(new CustomEvent("fotoPerfilChanged", { detail: { foto_perfil: nuevaFoto } }));
          }
        } catch (err) {
          setFotoError('Error al subir la imagen');
          console.error(err);
        } finally {
          setUploadingFoto(false);
        }
      };
      reader.readAsDataURL(file);
    } catch (err) {
      setFotoError('Error al procesar la imagen');
      setUploadingFoto(false);
    }
  };

  // Función para eliminar foto de perfil
  const handleDeleteFoto = async () => {
    if (!fotoPerfil) return;
    
    setUploadingFoto(true);
    try {
      await deleteFotoPerfil();
      setFotoPerfil(null);
      // Actualizar localStorage
      const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
      delete authUser.foto_perfil;
      localStorage.setItem("authUser", JSON.stringify(authUser));
      // Disparar evento para actualizar el topbar
      window.dispatchEvent(new CustomEvent("fotoPerfilChanged", { detail: { foto_perfil: null } }));
    } catch (err) {
      setFotoError('Error al eliminar la imagen');
    } finally {
      setUploadingFoto(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const updatedUser = {
      id: usuario.id,
      nombre: nombre.trim(),
      apellido: apellido.trim(),
      correo: correo,
      telefono: telefono.trim(),
      usuario: usuarioRol.trim(),
      activo: activo,
      contrasena: contrasena.trim(),
      farmacia_id: usuario.farmacia,
      perfil: perfil,
      creado: creado,
      actualizado: null,
    };

    // console.log("updatedUser:", updatedUser);
    dispatch(editUser(updatedUser));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Editar Perfil" pageTitle="Dashboards" url={`/`} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  {errorMsg && errorMsg ? (
                    <Alert color={colorMsg}> {error} </Alert>
                  ) : null}
                </CardHeader>
                <CardBody>
                  {loading ? (
                    <div className="text-center">
                      <Spinner color="primary"> Loading... </Spinner>
                    </div>
                  ) : exito && usuario ? (
                    <Form onSubmit={handleSubmit}>
                      {/* Sección de Foto de Perfil */}
                      <Row className="mb-4">
                        <Col lg={12}>
                          <div className="d-flex align-items-center gap-4">
                            <div className="position-relative">
                              <img
                                src={fotoPerfil || avatarDefault}
                                alt="Foto de perfil"
                                className="rounded-circle"
                                style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                onError={(e) => { e.target.src = avatarDefault; }}
                              />
                              {uploadingFoto && (
                                <div 
                                  className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded-circle"
                                  style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                                >
                                  <Spinner color="light" size="sm" />
                                </div>
                              )}
                            </div>
                            <div>
                              <h5 className="mb-2">Foto de Perfil</h5>
                              <p className="text-muted mb-2">JPG, PNG o GIF. Máximo 5MB.</p>
                              <div className="d-flex gap-2">
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  onChange={handleFotoChange}
                                  accept="image/*"
                                  style={{ display: 'none' }}
                                />
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => fileInputRef.current?.click()}
                                  disabled={uploadingFoto}
                                >
                                  <i className="ri-upload-2-line me-1"></i>
                                  Subir Foto
                                </Button>
                                {fotoPerfil && (
                                  <Button
                                    color="danger"
                                    size="sm"
                                    outline
                                    onClick={handleDeleteFoto}
                                    disabled={uploadingFoto}
                                  >
                                    <i className="ri-delete-bin-line me-1"></i>
                                    Eliminar
                                  </Button>
                                )}
                              </div>
                              {fotoError && (
                                <Alert color="danger" className="mt-2 mb-0 py-1 px-2">
                                  {fotoError}
                                </Alert>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mb-4" />
                      <Row lg={12} className="p-3">
                        <Col xxl={6} md={6}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="nombre">
                              Nombre <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="nombre"
                              name="nombre"
                              minLength={3}
                              maxLength={50}
                              value={nombre}
                              required
                              onChange={(e) => setNombre(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col xxl={6} md={6}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="apellido">
                              Apellido <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="apellido"
                              name="apellido"
                              minLength={3}
                              maxLength={50}
                              required
                              value={apellido}
                              onChange={(e) => setApellido(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col xxl={6} md={6}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="correo">
                              Email <span className="text-danger">*</span>
                            </Label>

                            <Input
                              type="email"
                              className="form-control"
                              id="email"
                              name="email"
                              required
                              value={correo}
                              onChange={(e) => setCorreo(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col xxl={6} md={6}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="telefono">
                              Teléfono <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="phone"
                              className="form-control"
                              id="telefono"
                              name="telefono"
                              required
                              minLength={11}
                              maxLength={11}
                              value={telefono}
                              onChange={(e) => setTelefono(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col xxl={6} md={6}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="usuario">
                              Usuario <span className="text-danger">*</span>
                            </Label>

                            <Input
                              type="text"
                              className="form-control"
                              id="usuario"
                              name="usuario"
                              required
                              minLength={5}
                              maxLength={50}
                              value={usuarioRol}
                              onChange={(e) => setUsuarioRol(e.target.value)}
                            />
                          </div>
                        </Col>

                        <Col xxl={6} md={6}>
                          <div className="mb-3 position-relative">
                            <Label className="form-label" htmlFor="contrasena">
                              Contraseña <span className="text-danger">*</span>
                            </Label>

                            <div className="position-relative">
                              <Input
                                type={showPassword ? "text" : "password"}
                                className={`form-control ${
                                  passwordError ? "is-invalid" : ""
                                }`}
                                id="contrasena"
                                name="contrasena"
                                required
                                minLength={8}
                                maxLength={50}
                                value={contrasena}
                                onChange={handlePasswordChange}
                              />
                              <button
                                type="button"
                                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                onClick={togglePasswordVisibility}
                                style={{ height: "100%", border: "none" }}
                              >
                                <i
                                  className={`ri-eye${
                                    showPassword ? "-off" : ""
                                  }-line align-middle`}
                                ></i>
                              </button>

                              {passwordError && (
                                <div className="invalid-feedback">
                                  <ul className="list-unstyled mb-0">
                                    {passwordError.map((error, index) => (
                                      <li key={index}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        </Col>
                        {perfil === "Administrador" ? (
                          <>
                            <Col xxl={6} md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="perfil">
                                  Perfil <span className="text-danger">*</span>
                                </Label>

                                <Select
                                  defaultValue={perfilOptionSelect}
                                  onChange={(selectedOption) => {
                                    setPerfil(selectedOption.value);
                                  }}
                                  options={opcionesPerfil.map((item) => ({
                                    value: item,
                                    label: item,
                                  }))}
                                  id="perfil"
                                  className="js-example-basic-single mb-0"
                                  name="perfil"
                                  required
                                />
                              </div>
                            </Col>

                            <Col xxl={6} md={6}>
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="activo">
                                  Activo <span className="text-danger">*</span>
                                </Label>

                                <Select
                                  defaultValue={activoOptionSelect}
                                  onChange={(selectedOption) => {
                                    setActivo(selectedOption.value === "true");
                                  }}
                                  options={[
                                    { value: "true", label: "Si" },
                                    { value: "false", label: "No" },
                                  ]}
                                  required
                                  id="activo"
                                  className="js-example-basic-single mb-0"
                                  name="activo"
                                />
                              </div>
                            </Col>
                          </>
                        ) : null}
                      </Row>

                      <Row className="align-items-end">
                        <Col lg={6}>
                          <div className="mt-4 mb-3">
                            <Link to="/">
                              <Button className="btn btn-info btn-label left ms-auto nexttab nexttab">
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 ms-2"></i>
                                Cancelar
                              </Button>
                            </Link>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mt-4 mb-3 text-end">
                            <button
                              type="submit"
                              className="btn btn-success btn-label right ms-auto nexttab nexttab"
                            >
                              {loading ? (
                                <Spinner size="sm" className="me-2">
                                  {" "}
                                  Loading...{" "}
                                </Spinner>
                              ) : null}
                              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                              Actualizar Perfil
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  ) : null}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditarUsuario;
